
import Hero from './components/Hero';
import AboutLawyer from './components/AboutLawyer';
import VisaIntro from './components/VisaIntro';
import WhoCanApply from './components/WhoCanApply';
import Requirements from './components/Requirements';
import ApplicationProcess from './components/ApplicationProcess';
import PorQueNoSolo from './components/PorQueNoSolo';
import Taxation from './components/Taxation';
import BeckhamCalculator from './components/BeckhamCalculator';
import ConsultationPricing from './components/ConsultationPricing';
import Testimonios from './components/Testimonios';
import CTA from './components/CTA';
import Footer from './components/Footer';
import LiveNotifications from './components/LiveNotifications';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <LiveNotifications />
      <Hero />
      <AboutLawyer />
      <VisaIntro />
      <WhoCanApply />
      <Requirements />
      <ApplicationProcess />
      <PorQueNoSolo />
      <Taxation />
      <BeckhamCalculator />
      <ConsultationPricing />
      <Testimonios />
      <CTA />
      <Footer />
    </div>
  );
}
